var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMask)?_c('img',{attrs:{"src":_vm.domain + _vm.src,"alt":_vm.alt}}):_c('div',{style:({ maskImage: `url(${_vm.domain + _vm.src})` })})
}
var staticRenderFns = []

export { render, staticRenderFns }